<template>
  <Modal name="REMOVE_SERVICE_PROVIDER_REALESTATE" :title="titleLabel" actions>
    <template #body>
      <p class="font-weight-bold mb-1">{{ warningMessage }}</p>
      <p>{{ deleteMessage }}</p>
    </template>

    <template #actions>
      <div class="d-flex gap-1">
        <v-btn
          @click="closeModal"
          :disabled="isServiceProviderLoading"
          elevation="0"
          text
        >
          {{ cancelLabel }}
        </v-btn>
        <v-btn
          @click="remove"
          :loading="isServiceProviderLoading"
          color="primary"
          elevation="0"
        >
          {{ removeLabel }}
        </v-btn>
      </div>
    </template>
  </Modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Modal from '@/components/app/Modal.vue'

export default {
  name: 'RemoveServiceProviderRealEstate',

  components: { Modal },

  props: {
    client: {
      type: Object,
      required: true
    }
  },

  computed: {
    ...mapGetters(['isServiceProviderLoading']),

    deleteMessage() {
      return this.$t('deleteModal.warningMessage', {
        entityName: this.client.name || ''
      })
    }
  },

  methods: {
    ...mapActions([
      'closeModal',
      'deleteServiceProviderRealEstate',
      'listServiceProviderCustomers'
    ]),

    async remove() {
      try {
        await this.deleteServiceProviderRealEstate({ id: this.client.id })
        await this.listServiceProviderCustomers()
        this.closeModal()
        this.$emit('success')
      } catch (error) {
        this.$emit('error', error.message || this.$t('forms.errors.generic'))
      }
    }
  },

  data() {
    return {
      titleLabel: this.$t('realEstateUsers.label.remove'),
      warningMessage: this.$t('deleteModal.warning'),
      cancelLabel: this.$t('deleteModal.buttons.cancel'),
      removeLabel: this.$t('realEstateUsers.label.remove')
    }
  }
}
</script>